<div class="capacity-element" [ngClass]="capacityType === 'icons' && 'capacity-with-icons'">
  <div nz-row class="capacity-title">
    <ng-container>
      <ng-content select="[titleIcon]">
      </ng-content>
    </ng-container>
    <span>
      {{capacityTitle}}
    </span>
    <span *ngIf="isUnlimited" class="unlimited">({{ 'FORM.LABEL.UNLIMITED' | translate }})</span>
      <span
        *ngIf="hasTooltip"
        class="info-tooltip"
        nz-icon
        nzType="question-circle"
        nzTheme="outline"
        [nzTooltipTitle]="capacityTitleTooltip"
        nzTooltipPlacement="top"
        nz-tooltip
      >
      </span>
  </div>
  <div class="speed-text">
    <ng-content select="[speedText]">
    </ng-content>
  </div>
  <ng-container *ngIf="capacityType === 'data' || capacityType === 'voice' || capacityType === 'sms'">
    <div
      nz-row
      [nzTooltipTitle]="progressBarTooltip"
      nzTooltipPlacement="top"
      nz-tooltip
    >
      <div nz-col nzFlex="100" class="progress-bar">
        <nz-progress
          [nzPercent]="capacityPercentage === 0 ? 3 : capacityPercentage"
          [nzSize]="progressBarSize"
          [nzStrokeColor]="progressBarColor"
          [nzShowInfo]="false"
          nzStatus="active"
        >
        </nz-progress>
      </div>
    </div>
    <div nz-row nzJustify="space-between" class="plan-data">
      <div nz-col class="consumed" [nzFlex]="50" nz-typography nzEllipsis="true">
        <span class="consumed-title">
          {{ 'FORM.LABEL.CONSUMED' | translate }}
        </span>
        <span class="data">{{consumedData}}</span>
      </div>
      <div nz-col class="total" [nzFlex]="50" nz-typography nzEllipsis="true">
        <ng-container *ngIf="!isUnlimited;">
          <span class="consumed-title">
            {{ PLANS_PREFIX + 'INCLUDED' | translate }}
          </span>
        </ng-container>
        <ng-container *ngIf="isUnlimited">
          <ng-container *ngIf="capacityType === 'data'; else fairUseLimit">
            <span class="consumed-title">
              {{ PLANS_PREFIX + 'INCLUDED' | translate }}
            </span>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="isUnlimited && capacityType === 'data'; else capacityDataDynamic">
          <span class="data">{{ 'FORM.LABEL.UNLIMITED' | translate }}</span>
        </ng-container>
        <ng-template #capacityDataDynamic>
          <span class="data">{{capacityData}}</span>
        </ng-template>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="capacityType === 'noSupport'">
    <div nz-row nz-typography nzAlign="middle" class="no-support">
      <span nz-icon nzType="warning" nzTheme="fill"></span>
      <span>{{noSupportText}}</span>
    </div>
  </ng-container>
  <ng-container *ngIf="capacityType === 'icons'">
    <div nz-row nzAlign="middle" class="icons-type">
      <ng-content select="[iconsContainer]">
      </ng-content>
    </div>
  </ng-container>
</div>

<ng-template #fairUseLimit>
  <span class="consumed-title">
    {{ PLANS_PREFIX + 'FAIR_USE_LIMIT' | translate }}
    <a target="_blank" href="https://oxio.com/legal/fair-use/">
      <i class="far fa-external-link info-tooltip"></i>
    </a>
  </span>
</ng-template>
